import { Route } from "react-router-dom";
import {
  RTCategoryWiseMerchant,
  RTConfigure,
  RTHome,
  RTLand,
  RTMasterCategory,
  RTOutletsProduct,
  RTProduct,
  RTProductList,
  RTPromoProductList,
  RTQRProductList,
  RTSettings,
  RTStartup,
  RTTypeLand,
} from "../screens/sc-home";
import {
  PT_CATEGORYWISE_MERCHANT,
  PT_CONFIGURE,
  PT_FILTER_OUTLETS_PRODUCTS,
  PT_HOME,
  PT_INDEX,
  PT_LAND,
  PT_MASTERCATEGORY,
  PT_PRODUCT,
  PT_PRODUCT_LIST,
  PT_PROMO_PRODUCT_LIST,
  PT_QR_LIST,
  PT_SETTINGS,
  PT_STARTUP,
  PT_TYPE_LAND,
} from "./paths/pt-home";
import { KEY_GENERATOR } from "../../functions/funtion";
import React from "react";
let RouteArray = [
  [
    <Route
      key={KEY_GENERATOR()}
      path={PT_INDEX}
      element={
        <img
          src={require("../images/404.gif")}
          alt="avas"
          style={{
            display: "block",
            width: "100%",
            position: "absolute",
            objectFit: "cover",
            objectPosition: "top",
            top: "25%",
          }}
        />
      }
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_CONFIGURE}
      element={<RTConfigure />}
    />,
    <Route key={KEY_GENERATOR()} path={PT_SETTINGS} element={<RTSettings />} />,
    <Route key={KEY_GENERATOR()} path={PT_STARTUP} element={<RTStartup />} />,
    <Route key={KEY_GENERATOR()} path={PT_LAND} element={<RTLand />} />,
    <Route key={KEY_GENERATOR()} path={PT_HOME} element={<RTHome />} />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_TYPE_LAND}
      element={<RTTypeLand />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_PRODUCT_LIST}
      element={<RTProductList />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_PROMO_PRODUCT_LIST}
      element={<RTPromoProductList />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_QR_LIST}
      element={<RTQRProductList />}
    />,
    <Route key={KEY_GENERATOR()} path={PT_PRODUCT} element={<RTProduct />} />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_FILTER_OUTLETS_PRODUCTS}
      element={<RTOutletsProduct />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_MASTERCATEGORY}
      element={<RTMasterCategory />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_CATEGORYWISE_MERCHANT}
      element={<RTCategoryWiseMerchant />}
    />,
  ],
];

export default RouteArray;
